class PaymentAccount {
    constructor(account,accounts) {
        this.account = account;
        this.accounts = accounts;
    }
}

export default PaymentAccount;